import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/lib/AdminAuth";
import { Loader2 } from "lucide-react";

export default function RequireAdminAuth({ children }) {
  const { user } = useAdminAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-ra-paper text-ra-ink/60">
        <Loader2 size={18} className="animate-spin" />
      </div>
    );
  }
  if (user === null) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
